<script setup lang="ts">
import type { ArticleTagListProps } from '@/types/appTypes'

const props = withDefaults(defineProps<ArticleTagListProps>(), { header: null })

const app = useNuxtApp()
</script>

<template>
  <div class="p-articleTaglist">
    <div
      v-if="header"
      class="p-articleTaglist_header"
    >
      {{ header }}
    </div>
    <div class="p-articleTaglist_tags">
      <template
        v-for="item in items"
        v-bind:key="item.id"
      >
        <NuxtLink
          v-bind:to="{ name: 'tag-id-tab', params: { id: item.id, tab: props.articleName } }"
          v-bind:class="app.$device.isMobileOrTablet ? 'c-tagItem c-tagItem_sp' : 'c-tagItem'"
        >
          #{{ item.name }}
        </NuxtLink>
      </template>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/css/foundation/mixin/responsive";

.p-articleTaglist {
  margin-top: 35px;
  padding: 30px;
  background-color: var(--color_background_whiteblue);
  line-height: 1;

  @include responsive.mq_down(sp) {
    padding: 15px;
  }

  &_header {
    margin-bottom: 24px;
    font-size: 18px;
    font-weight: bold;

    @include responsive.mq_down(sp) {
      margin-bottom: 16px;
      font-size: 16px;
    }
  }

  &_tags {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    margin-left: -4px;
  }
}

.c-tagItem {
  display: flex;
  align-items: center;
  margin: 4px;
  padding: 0 16px;
  border-radius: 12px;
  background-color: var(--g_color_background_white);
  color: var(--color_text_base);
  font-family: var(--g_font_family_SawarabiGothic);
  font-size: 14px;
  line-height: 24px;
  white-space: nowrap;

  &:hover {
    opacity: 0.8;
  }
}
</style>
